// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteCollaboratorMutationVariables = Types.Exact<{
  collaboratorId: Types.Scalars['ID']['input'];
}>;


export type DeleteCollaboratorMutation = { __typename?: 'Mutation', deleteCollaborator: string };

export const Operations = {
  Mutation: {
    DeleteCollaborator: 'DeleteCollaborator' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DeleteCollaboratorDocument = gql`
    mutation DeleteCollaborator($collaboratorId: ID!) {
  deleteCollaborator(id: $collaboratorId)
}
    `;
export type DeleteCollaboratorMutationFn = Apollo.MutationFunction<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>;

/**
 * __useDeleteCollaboratorMutation__
 *
 * To run a mutation, you first call `useDeleteCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollaboratorMutation, { data, loading, error }] = useDeleteCollaboratorMutation({
 *   variables: {
 *      collaboratorId: // value for 'collaboratorId'
 *   },
 * });
 */
export function useDeleteCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>(DeleteCollaboratorDocument, options);
      }
export type DeleteCollaboratorMutationHookResult = ReturnType<typeof useDeleteCollaboratorMutation>;
export type DeleteCollaboratorMutationResult = Apollo.MutationResult<DeleteCollaboratorMutation>;
export type DeleteCollaboratorMutationOptions = Apollo.BaseMutationOptions<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>;